import type { VenueTraderInfo } from '@/legacy-api/orders-slice.gen'
import type { VenueTraderConfig } from '@/types/api/legacy-trader-profile'

// The orders-api schema still marks the custodian fields required until they
// are removed from it; the backend ignores their values.
export function toVenueTraderInfo(
  venueMpid: string,
  venueTraderId: string,
): VenueTraderInfo {
  return {
    venue_mpid: venueMpid,
    venue_trader_id: venueTraderId,
    custodian_id: '',
    custodian_account_at_venue: '',
  }
}

export function flattenVenueTraderConfigs(
  venueTraderConfigs: Record<string, VenueTraderConfig> | undefined,
): VenueTraderInfo[] {
  if (!venueTraderConfigs) return []
  return Object.entries(venueTraderConfigs).map(([venueMpid, config]) =>
    toVenueTraderInfo(venueMpid, config.venue_trader_id),
  )
}
